import { render } from "./create_profile_tabs.html?vue&type=template&id=43221226&external"
import script from "./create_profile_tabs.js?vue&type=script&lang=js&external"
export * from "./create_profile_tabs.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__